import Spinner from '@components/common/spinner'
import Logo from '@components/common/logo'
import { useRouter } from 'next/router'
import React, { useEffect, useState } from 'react'
import { CheckCircle } from 'react-feather'

export default function SuccessLoadingPage() {
  const [timer, setTimer] = useState(4)
  const router = useRouter()

  useEffect(() => {
    // Check if UUID is available
    if (!router.query.uuid) return

    const nextPage = `/payment/${router.query.uuid}/thank-you`
    const interverId = setInterval(() => {
      setTimer((prevTimer) => {
        if (prevTimer == 1) {
          router.push(nextPage)
          clearInterval(interverId)
        }
        return prevTimer - 1
      })
    }, 1000)

    return () => clearInterval(interverId)
  }, [router.query.uuid])

  const isRazorpay = router.query.viaRzp && router.query.viaRzp === '1'

  return (
    <React.Fragment>
      <Logo
        withText
        className="m-5"
        style={{ width: '120px', height: '32px' }}
        height={32}
        width={120}
      />
      <div
        className="relative flex flex-col items-center text-grey overflow-hidden"
        style={{ marginTop: '18rem' }}
      >
        <Spinner classes="w-12 text-green-200" />
        <div className="text-2xl flex items-center gap-x-2 text-green-200 font-600 my-4">
          <CheckCircle className="text-green-200" />
          {isRazorpay ? 'Auto-pay' : 'Payment'} Confirmed.
        </div>
        <div className="text-lg">
          Redirecting you to the next page in{' '}
          <span className="text-2xl">{timer}</span>
        </div>
      </div>
    </React.Fragment>
  )
}
